import arrayMutators from 'final-form-arrays';

type SetFieldValueArgs = [string, unknown];

// @ts-ignore arrayMutators is not typed
export const customSectionFormMutators = {
  ...arrayMutators,
  setFieldValue: (
    args: SetFieldValueArgs,
    state: unknown,
    utils: { changeValue: (state: unknown, name: string, fn: () => unknown) => void },
  ) => {
    utils.changeValue(state, args[0], () => args[1]);
  },
};
